import { Container, Stack } from '@mui/material';
import { fetchMyCollaborations } from '../../lib/api';
import { navigate } from '../../lib/navigation';
import { useOwnedSection } from '../../lib/useOwnedSection';
import Button from '../../components/Button';
import CollaborationCard from './CollaborationCard';
import EmptyState from '../../components/EmptyState';
import PageHeader from '../../components/PageHeader';
import SectionLoading from '../../components/SectionLoading';

function CollaborationsPage() {
  const { items: collaborations, loading } = useOwnedSection(fetchMyCollaborations, '/v1/profiles/me/collaborations', (next) => ({
    collaborations: next,
  }));

  if (loading) return <SectionLoading />;

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <PageHeader
        title="Brand history"
        description="Add lightweight past brand work for the public profile and generated media kit."
        action={<Button onClick={() => navigate('/dashboard/collaborations/new')}>Add brand work</Button>}
      />
      {collaborations.length === 0 ? (
        <EmptyState
          title="No brand work yet"
          text="Add a past collaboration to build your public profile history. This is optional for publishing."
          action={<Button onClick={() => navigate('/dashboard/collaborations/new')}>Add your first brand collaboration</Button>}
        />
      ) : (
        <Stack spacing={2}>
          {collaborations.map((collab) => (
            <CollaborationCard key={collab.id} collab={collab} />
          ))}
        </Stack>
      )}
    </Container>
  );
}

export default CollaborationsPage;
